const supportsHistory = window.history && window.history.pushState;
export default supportsHistory;



// WEBPACK FOOTER //
// ./src/main/js/util/supportsHistory.js